import {
  BrowserDetection,
  ConfigService,
  RunConfigService
} from "@nuskin/ns-util";
import { ProductData, Product } from "@nuskin/ns-product-lib";
import { getConfiguration } from "@nuskin/configuration-sdk";

/**
 * Used to retrieve product content and product status for products requested from the product data lambda.
 * @param skus The product skus to request data for.
 * @param locale The locale for market-specific product data and translations.
 * @return {Promise<*>}
 */
async function getProductData(skus, locale) {
  let runConfig = RunConfigService.getRunConfig();
  if (locale) {
    const [language, country] = locale.split("_"); // -> [en, US]
    runConfig = { language, country };
  }
  const marketConfig = ConfigService.getMarketConfig();
  const equinoxMarketConfig = (
    await getConfiguration([
      "Url",
      "Basic",
      "Shopping",
      "ADP",
      "Cart",
      "Loyalty",
      "Checkout",
      "Equinox_Markets"
    ])
  ).Equinox_Markets;
  const isEquinoxEnabled = equinoxMarketConfig.active;
  const useGraphQl = equinoxMarketConfig.MySite_graphql_active_list.includes(
    runConfig.country
  );
  const productsMapped = [];
  if (typeof skus === "string") {
    const newSkus = [];
    newSkus.push(skus);
    skus = newSkus;
  }

  //START OF LEGACY MARKET WITHOUT GRAPHQL
  if (!useGraphQl && !isEquinoxEnabled) {
    const products = await ProductData.getProductData(
      skus,
      runConfig.language,
      runConfig.country,
      isEquinoxEnabled
    );
    const productData = processProductDataResponse(marketConfig, products);
    return productData;
  }
  //START OF LEGACY MARKET WITHOUT GRAPHQL

  const response = await ProductData.getProductData(
    skus,
    runConfig.language,
    runConfig.country,
    isEquinoxEnabled
  );
  const products = response.data.data.products;

  if (useGraphQl) {
    productsMapped.push({
      data: {
        status: "200",
        products: response.data.data.products,
        count: response.data.data.count
      }
    });
  } else {
    productsMapped.push({ data: { products: products } });
  }

  const pReturn = processProductDataResponse(marketConfig, productsMapped[0]);

  return pReturn;
}

function processProductDataResponse(marketConfig, productDataResponse) {
  if (!productDataResponse || !productDataResponse.data) {
    return undefined;
  }

  let productData = productDataResponse.data;
  if (productData.data) {
    // the actual response is nested in another data for now
    productData = productData.data;
  }

  if (productData.products && productData.products.length) {
    const siteUrl = marketConfig.siteUrl;
    const isEdge = BrowserDetection.isEdge();
    const isFirefox = BrowserDetection.isFirefox();

    productData.products = productData.products.map((pdata) =>
      mapProductFromResponse(siteUrl, isEdge, isFirefox, pdata)
    );
  }

  return productData;
}

function mapProductFromResponse(siteUrl, isEdge, isFirefox, pdata) {
  let product;
  if (pdata instanceof Product) {
    product = new Product(pdata.toJSON());
  } else {
    product = new Product(pdata);
  }

  // set the base url for images, etc
  product.setBaseUrl(siteUrl);

  // fix image paths for non-edge/firefox
  if (!isEdge && !isFirefox) {
    if (
      product.fullImage &&
      !product.fullImage.includes("media.nuskin.com/transform")
    ) {
      product.fullImage = product.fullImage
        ? `${product.fullImage.split("?")[0]}?format=pjpg`
        : undefined;
      product.thumbnail = product.thumbnail
        ? `${product.thumbnail.split("?")[0]}?format=pjpg`
        : undefined;
    }
  }

  return product;
}

export default {
  getProductData
};
